
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../../components/base/Button';

export const AdditionalServicesSection: React.FC = () => {
  const additionalServices = [
    {
      title: "Adventure",
      image: "/images/additional-services-parachute.jpg",
      description: "Push your limits with thrilling adventure activities including skydiving, mountain climbing, and extreme sports.",
      buttonText: "Quote Request"
    },
    {
      title: "Staycation",
      image: "/images/additional-services-glamping.jpg",
      description: "Discover luxury close to home with our premium staycation packages featuring the finest local accommodations.",
      buttonText: "Enquire Now"
    },
    {
      title: "Experiences",
      image: "/images/additional-services-train.jpg",
      description: "Immerse yourself in unique cultural experiences and once-in-a-lifetime adventures around the world.",
      buttonText: "Read More"
    },
    {
      title: "Self Drive Tours",
      image: "/images/additional-services-gps.jpg",
      description: "Take control of your journey with our self-drive tour packages complete with GPS navigation and route planning.",
      buttonText: "Quote Request"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {additionalServices.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="relative">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-64 object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {service.title}
                </h3>

                <p className="text-gray-700 mb-6 leading-relaxed">
                  {service.description}
                </p>

                {(() => {
                  const title = service.title?.toLowerCase() || '';
                  const btn = (service.buttonText || '').toLowerCase();
                  let to = '/contact';

                  if (btn.includes('quote') || btn.includes('enquire')) to = '/contact';
                  else if (title.includes('experience') || btn.includes('read')) to = '/experience';
                  else if (title.includes('adventure')) to = '/adventure';
                  else if (title.includes('stay')) to = '/stays';
                  else if (title.includes('drive')) to = '/experience';

                  return (
                    <Link to={to} className="block">
                      <Button variant="primary" size="sm" className="w-full">
                        <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
                        {service.buttonText}
                      </Button>
                    </Link>
                  );
                })()}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
